import * as React from "react";
import { Tooltip } from "@mantine/core";
import { IPerson } from "../persons/person";

export enum BasketballGrade {
  apprentice1 = 1, // Apprentice (Running next to Master)
  apprentice2 = 2, // Apprentice (Running Opposite to fellow official)
  c = 3,
  b = 4,
  a = 5,
  l1 = 6,
  l2 = 7,
  l3 = 8,
  l4 = 9,
  l5 = 10,
}

export namespace BasketballGrade {
  export function all(): BasketballGrade[] {
    return [
      BasketballGrade.apprentice1,
      BasketballGrade.apprentice2,
      BasketballGrade.c,
      BasketballGrade.b,
      BasketballGrade.a,
      BasketballGrade.l1,
      BasketballGrade.l2,
      BasketballGrade.l3,
      BasketballGrade.l4,
      BasketballGrade.l5,
    ];
  }

  export function parse(grade: string): BasketballGrade | null {
    if (!grade) return null;
    const g = grade.toLowerCase();
    if (g.startsWith("apprentice")) return BasketballGrade.apprentice2; // Apprentice
    if (g.startsWith("c grade")) return BasketballGrade.c; // C Grade
    if (g.startsWith("b grade")) return BasketballGrade.b; // B Grade
    if (g.startsWith("a grade")) return BasketballGrade.a; // A Grade (Old 1A)
    if (g.startsWith("level 1")) return BasketballGrade.l1; // Level 1
    if (g.startsWith("level 2")) return BasketballGrade.l2; // Level 2
    if (g.startsWith("level 3")) return BasketballGrade.l3; // Level 3
    if (g.startsWith("level 4")) return BasketballGrade.l4; // Level 4
    if (g.startsWith("level 5")) return BasketballGrade.l5; // Level 5
    return null;
  }

  export function componentFromPersonWithDecorations(
    person: IPerson,
  ): React.ReactElement | undefined {
    if (!person.referee?.grade) {
      return undefined;
    }
    const base = BasketballGrade.toShortString(person.referee?.grade);
    const decorations: [string, string][] = [];
    if (person.referee?.plus) {
      decorations.push(["P", "Plus"]);
    }
    if (person?.referee?.isInterestedInPromotion) {
      decorations.push(["+", "Interested in promotion"]);
    }

    // <UncontrolledTooltip
    // placement="right"
    // target="UncontrolledTooltipExample"
    // >

    const r = (Math.random() + 1).toString(36).substring(7);

    const prepareElement = (el) =>
      `${el[1].toLowerCase().replaceAll(" ", "")}_${r}`;

    const decorationRef = decorations.map((_) => React.createRef());

    return React.createElement(
      "span",
      {},
      base,
      React.createElement(
        "sup",
        {},
        decorations.map((d, idx) =>
          React.createElement(
            Tooltip,
            {
              label: d[1],
              key: `decorated-basketball-grade-${person._id}-${d[1]}`,
            },
            React.createElement(
              "a",
              {
                id: prepareElement(d),
                href: "#",
                key: `decorated-basketball-grade-${person._id}-link-${d[0]}`,
              },
              d[0],
            ),
          ),
        ),
      ),
    );
  }

  export function stringFromPersonWithDecorations(
    person: IPerson,
  ): string | undefined {
    if (!person.referee?.grade) {
      return undefined;
    }
    const base = BasketballGrade.toShortString(person.referee?.grade);
    const decorations: string[] = [];
    if (person?.referee?.isInterestedInPromotion) {
      decorations.push("+");
    }
    if (person.referee?.plus) {
      decorations.push("P");
    }

    if (decorations.length == 0) {
      return base;
    }

    return `${base} [${decorations.join("")}]`;
  }

  export function toShortString(gr: BasketballGrade): string {
    switch (gr) {
      case BasketballGrade.apprentice1:
        return "Tr";
      case BasketballGrade.apprentice2:
        return "Ap";
      case BasketballGrade.c:
        return "C";
      case BasketballGrade.b:
        return "B";
      case BasketballGrade.a:
        return "A";
      case BasketballGrade.l1:
        return "VJBL";
      case BasketballGrade.l2:
        return "BV";
      case BasketballGrade.l3:
        return "N1";
      case BasketballGrade.l4:
        return "Nat";
      case BasketballGrade.l5:
        return "FIBA";
      default:
        return "-";
    }
  }
  export function toString(gr: BasketballGrade): string {
    if (typeof gr === "string" && !isNaN(gr)) gr = Number(gr);
    switch (gr) {
      case BasketballGrade.apprentice1:
        return "Trainee";
      case BasketballGrade.apprentice2:
        return "Apprentice (green)";
      case BasketballGrade.c:
        return "C Grade";
      case BasketballGrade.b:
        return "B Grade";
      case BasketballGrade.a:
        return "A Grade";
      case BasketballGrade.l1:
        return "VJBL";
      case BasketballGrade.l2:
        return "Big V";
      case BasketballGrade.l3:
        return "NBL1";
      case BasketballGrade.l4:
        return "National";
      case BasketballGrade.l5:
        return "FIBA";
      default:
        return "-";
    }
  }
}
